import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import CreateMemberListing from '@/modules/manage-member/components/CreateMember/components/CreateMemberListing'

function CreateMemberPage() {
	return (
		<PageContainer>
			<CreateMemberListing />
		</PageContainer>
	)
}

const GuardedCreateMemberPage = withUserPermission(CreateMemberPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_OPERATOR],
})

export default GuardedCreateMemberPage
